import { Form, Modal } from "react-bootstrap";
import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { useCompanyOptions } from "../company";
import { _defaultBooking } from "./index";
import { db } from "../../index";
import { UserContext } from "../../App";
import Select from "react-select";
import { Button, OutlineButton } from "../../components/layout/OutlineButton";

export default function SelectDriverModal({
  show,
  setShow,
  booking,
  submit,
  fetching,
}) {
  const { userInfos } = useContext(UserContext);
  const driverSelect = useRef(null);
  const companyOptions = useCompanyOptions();
  const [driverOptions, setDriverOptions] = useState([]);
  const [driver, setDriver] = useState(booking?.driver);

  const handleCompanyChange = useCallback(
    (company, resetDriver = true) => {
      // setBookingField("driver", defaultBooking.driver);
      setDriverOptions([]);

      if (resetDriver) {
        driverSelect.current.select.clearValue();
      }

      let _driverOptions = [];
      db.ref("users/" + userInfos.uid + "/driver")
        .once("value")
        .then((snapshot) => {
          if (snapshot.exists()) {
            snapshot.forEach(function (childSnapshot) {
              if (
                company?.value &&
                childSnapshot.val()?.company?.id === company.value
              ) {
                _driverOptions.push({
                  value: childSnapshot.key,
                  label: childSnapshot.val().name,
                  data: {
                    ...childSnapshot.val(),
                    company: company.data,
                    id: childSnapshot.key,
                  },
                });
              }
            });

            setDriverOptions(_driverOptions);
          }
        });
    },
    [userInfos.uid]
  );

  useEffect(() => {
    setDriver(booking?.driver);
    if (booking?.driver?.company) {
      const company = companyOptions.find(
        (c) => c.value === booking.driver.company.id
      );
      handleCompanyChange(company, false);
    }
  }, [booking, companyOptions, handleCompanyChange]);

  return (
    <Modal show={show} onHide={() => setShow(false)}>
      <Modal.Header closeButton>
        <Modal.Title>Assigner chauffeur</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group controlId="company">
            <Form.Label>Société</Form.Label>
            <Select
              options={companyOptions}
              value={companyOptions.find(
                (c) => c.value === driver?.company?.id
              )}
              onChange={handleCompanyChange}
            />
          </Form.Group>
          <Form.Group controlId="driver">
            <Form.Label>Chauffeur</Form.Label>
            <Select
              ref={driverSelect}
              options={driverOptions}
              value={
                driver?.id
                  ? { value: driver.id, label: driver.name, data: driver }
                  : null
              }
              onChange={(obj) => setDriver(obj?.data || _defaultBooking.driver)}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>Numéro Macaron</Form.Label>
            <Form.Control
              type="text"
              placeholder="Numéro Macaron"
              value={driver?.macaron_number || ""}
              onChange={(e) =>
                setDriver((old) => ({ ...old, macaron_number: e.target.value }))
              }
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        {booking?.driver?.id && (
          <OutlineButton
            onClick={(e) => {
              e.preventDefault();
              if (!window.confirm("Are you sure you want to unset the driver?"))
                return;
              submit(_defaultBooking.driver);
            }}
            disabled={fetching}
          >
            Retirer le chauffeur
          </OutlineButton>
        )}
        <Button
          onClick={(e) => {
            e.preventDefault();
            submit(driver);
          }}
          disabled={fetching}
        >
          {fetching ? "Enregistrement..." : "Enregistrer les modifications"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
